import React, { Component } from "react";
import connect from "react-redux/es/connect/connect";
import Icon from "../Common/Icon";
import LineBadge from "./LineBadge";
import DienstregelingLink from "../Dienstregeling/Link";

class Lines extends Component {
  constructor() {
    super();
    this.state = {
      showMore: false,
    };
  }

  showMoreToggle = () => {
    this.setState({ showMore: !this.state.showMore });
  };

  render() {
    const { showMore } = this.state;
    const {
      loading,
      refreshing,
      stop,
      config: {
        lineLinkBaseUrl = "/",
        headerText = "Lijnen op deze halte",
        noRoutesText = "Er zijn momenteel geen aankomende dienstregelingen op deze halte",
        lineText = "Lijn",
        lineNumberText = "Lijnnummer",
        directionText = "richting",
        dienstregelingText = "dienstregeling",
        showMoreText = "Toon meer lijnen",
        showLessText = "Toon minder lijnen",
      },
    } = this.props;

    if (!stop) return null;

    const { routes = [] } = stop;
    return (
      <div
        className={`halte-lines ${
          loading && !refreshing ? "halte-lines--loading" : ""
        }`}
      >
        <div className="container container--center container--margin">
          <div className="halte-sub-header">
            <h2 className="halte-sub-header__title">
              <span className="halte-sub-header__icon">
                <Icon iconName="bus" />
              </span>
              {headerText}
            </h2>
            <div className="halte-sub-header__name">
              {stop.town}, {stop.name}
            </div>
          </div>
        </div>
        <div className="container container--margin">
          {!routes.length ? (
            <div className="halte-lines__empty">
              <div className="container container--center">
                <div className="halte-lines__empty-text">{noRoutesText}</div>
              </div>
            </div>
          ) : (
            <div className="container container--center">
              <ul className="halte-lines__list">
                {routes.map((route, index) => {
                  if (!showMore && index >= 5) return null;

                  /* const lineUrl = `${lineLinkBaseUrl}?route=%7B"route_id"%3A${route_id}%2C"route_long_name"%3A"${route_long_name}"%2C"route_short_name"%3A"${route_short_name}"%7D&date=${moment().format(
                        'DD-MM-YYYY'
                      )}&time=${moment().format('HH:mm')}&directionId=1` */
                  const {
                    route_id,
                    route_short_name,
                    route_long_name,
                    route_,
                    route_text_color,
                    route_color,
                  } = route;

                  // Een halte kan een route bevatten die een route_id van 0 heeft. In dat geval zijn alle velden null. Dus dit is een route die niet bestaat.
                  // Bijvoorbeeld: Halte met quayid  NL:S:34440150  en de naam  Texel - Alpha
                  if (!route_id) return null;

                  const to = route_long_name
                    ? route_long_name.split("-")[
                        route_long_name.split("-").length - 1
                      ]
                    : "?";

                  return (
                    <li className="halte-lines__list-item" key={route_id}>
                      <div className="halte-lines__line-numbers">
                        <LineBadge
                          route_id={route_id}
                          route_short_name={route_short_name}
                          route_long_name={route_long_name}
                          accessibilityPrefixText={lineNumberText}
                          text={route_short_name}
                          baseUrl={lineLinkBaseUrl}
                          route_text_color={route_text_color}
                          route_color={route_color}
                        />
                      </div>
                      <div className="halte-lines__line-name">
                        <b>
                          {lineText} {route_short_name}, {directionText} {to}
                        </b>
                        <p className="halte-lines__line-long-name">
                          {route_long_name}
                        </p>
                      </div>
                      <div className="halte-lines__dienstregeling-link">
                        <DienstregelingLink
                          className="link halte-lines__link"
                          route_id={route_id}
                          route_long_name={route_long_name}
                          route_short_name={route_short_name}
                          baseUrl={lineLinkBaseUrl}
                        >
                          {dienstregelingText}
                        </DienstregelingLink>
                      </div>
                    </li>
                  );
                })}
              </ul>
              {routes.length <= 5 ? null : (
                <button
                  className="btn--reset link halte-lines__toggle-more-btn"
                  onClick={this.showMoreToggle}
                >
                  {!showMore ? showMoreText : showLessText}{" "}
                  {showMore ? `-` : `+`}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    stop: state.stop.data,
    loading: state.stop.loading,
    refreshing: state.stop.refreshing,
  };
}, {})(Lines);



// WEBPACK FOOTER //
// ./src/components/Haltes/Lines.js